import { api, unwrap } from "./httpClient";
import type { TradingPosition } from "../types/api";

export const getPositions = () =>
  unwrap<TradingPosition[]>(api({ method: "GET", url: "/trading/positions" }));

export const closePosition = (marketSymbol: string) =>
  unwrap(
    api({
      method: "POST",
      url: `/trading/positions/${encodeURIComponent(marketSymbol)}/close`,
    })
  );


